import React from "react";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import labels from "../../../../constants/displayFields";
import BaseInfoModal from "./BaseInfoModal";
import useInventoryRequestData from "./hooks/useInventoryRequestData";

export default function AllocatedQuantityInfoModal({ asset, onClose }) {
  const { loading, error, getQuantityText } = useInventoryRequestData(
    "outstanding_orders", 
    asset?.itemId
  );

  const quantityText = getQuantityText(asset);
  const allocatedQuantity = parseInt(quantityText) || 0;

  return (
    <BaseInfoModal
      title={labels.allocated_quantity}
      onClose={onClose}
      loading={loading}
      error={error?.message}
    >
      {allocatedQuantity > 0 ? (
        <TextField
          value={quantityText}
          variant="outlined"
          size="small"
          fullWidth
          label={labels.allocated_quantity}
          InputProps={{
            readOnly: true,
          }}
          sx={{ mt: 2 }}
        />
      ) : (
        <Typography color="text.secondary" align="center" pt={4}>
          No outstanding orders currently include this asset.
        </Typography>
      )}
    </BaseInfoModal>
  );
}
